import { useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import FilterData from "../components/FilterData.jsx";
import Buyers from "../pages/Buyers/Buyers";
import BuyersDetails from "../pages/Buyers/BuyersDetails";
import Closed from "../pages/Closed/Closed";
import Companies from "../pages/Companies/Companies";
import CompanyDetails from "../pages/Companies/CompanyDetails";
import ContactDetails from "../pages/Contacts/ContactDetails";
import Contacts from "../pages/Contacts/Contacts";
import AddContractToClosed from "../pages/ContractToClosed/AddContractToClosed";
import StageDetailPage from "../pages/ContractToClosed/components/StageDetailPage.jsx";
import ContractToClosed from "../pages/ContractToClosed/ContractToClosed";
import EditContractToClosed from "../pages/ContractToClosed/EditContractToClosed";
import Dashboard from "../pages/Dashboard/Dashboard";
import Exclusives from "../pages/Exclusive/Exclusives";
import ExecutedLOI from "../pages/Executed LOI/Executed.jsx";
import Leads from "../pages/Leads/Leads";
import ForgotPassword from "../pages/Login/ForgotPassword";
import Login from "../pages/Login/Login";
import NewPassword from "../pages/Login/NewPassword";
import OtpVerification from "../pages/Login/OtpVerification";
import PasswordChangeSuccess from "../pages/Login/PasswordChangeSuccess";
import Logs from "../pages/Logs/Logs.jsx";
import Profile from "../pages/MyProfile/Profile";
import SuperAdminProfile from "../pages/MyProfile/SuperAdminProfile";
import Offers from "../pages/Offers/Offers";
import PageNotFound from "../pages/PageNotFound/PageNotFound";
import Pipeline from "../pages/Pipeline/Pipeline.jsx";
import AddProperty from "../pages/Properties/AddProperty";
import EditProperty from "../pages/Properties/EditProperty";
import Properties from "../pages/Properties/Properties";
import PropertiesDemo from "../pages/Properties/PropertyDemo.jsx";
import PropertyDetails from "../pages/Properties/PropertyDetails";
import Proposals from "../pages/Proposals/Proposals";
import AddScorecard from "../pages/ScoreCard/AddScorecard.jsx";
import ScoreCardHistory from "../pages/ScoreCard/Component/ScoreCardHistory.jsx";
import ScoreCard from "../pages/ScoreCard/ScoreCard.jsx";
import BuyerArchive from "../pages/Settings/BuyerArchive";
import ClosedArchive from "../pages/Settings/ClosedArchive.jsx";
import CompanyArchive from "../pages/Settings/CompanyArchive";
import CompanyTag from "../pages/Settings/CompanyTag.jsx";
import ConnectedApp from "../pages/Settings/ConnectedApp";
import ContactArchive from "../pages/Settings/ContactArchive";
import ContactTag from "../pages/Settings/ContactTag";
import ContractToClosedArchive from "../pages/Settings/ContractToClosedArchive.jsx";
import ConversationRate from "../pages/Settings/ConverstionRate.jsx";
import DesignatedAgents from "../pages/Settings/DesignatedAgents";
import EXclusiveArchive from "../pages/Settings/ExclusiveArchive.jsx";
import ExecutedloiArchive from "../pages/Settings/ExecutedLOIAechive.jsx";
import LeadRoundRobin from "../pages/Settings/LeadRoundRobin.jsx";
import LeadSources from "../pages/Settings/LeadSources";
import LeadType from "../pages/Settings/LeaseType.jsx";
import Mailchimp from "../pages/Settings/Mailchimp.jsx";
import PropertyArchive from "../pages/Settings/PropertyArchive";
import PropertyTags from "../pages/Settings/PropertyTags";
import PropertyTypes from "../pages/Settings/PropertyTypes";
import StageDetailPageArchive from "../pages/Settings/StageDetailPageArchive.jsx";
import SystemAlerts from "../pages/Settings/SystemAlerts.jsx";
import Tenants from "../pages/Settings/Tenants";
import UnderContractArchive from "../pages/Settings/UnderContractArchive.jsx";
import CreateSmartPlan from "../pages/Smartplans/CreateSmartPlan";
import Smartplan from "../pages/Smartplans/Smartplan";
import Tasks from "../pages/Tasks/Tasks";
import UnderContract from "../pages/UnderContract/UnderContract";
import UserProfileDetail from "../pages/Users/UserProfileDetail";
import Users from "../pages/Users/Users";
import { ProtectedRoutes } from "./ProtectedRoutes";





const AppRoutes = () => {
  const userType = useSelector((state) => state.userType);

  return (
    <BrowserRouter>
      <Routes>

        <Route path="/login" index element={<Login />} />
        <Route path="/forgot-password" index element={<ForgotPassword />} />
        <Route path="/otp-verify" index element={<OtpVerification />} />
        <Route path="/new-password" index element={<NewPassword />} />
        <Route
          path="/password-success"
          index
          element={<PasswordChangeSuccess />}
        />
        <Route path="*" element={<PageNotFound />} />

        {/* Protected Routes  */}
        <Route element={<ProtectedRoutes />}>
          {(userType === 1 || userType === 2 || userType === 4) && (
            <Route path="/settings/users" index element={<Users />} />
          )}
          <Route path="/" index element={<Dashboard />} />
          <Route path="/user/:id" index element={<UserProfileDetail />} />
          <Route path="/contacts" index element={<Contacts />} />
          <Route path="/contact/:id" index element={<ContactDetails />} />
          <Route path="/companies" index element={<Companies />} />
          <Route path="/company/:id" index element={<CompanyDetails />} />
          <Route path="/properties" index element={<Properties />} />
          <Route path="/property/:id" index element={<PropertyDetails />} />
          <Route path="/add-property" index element={<AddProperty />} />
          <Route path="/edit-property/:id" index element={<EditProperty />} />
          <Route path="/buyers" index element={<Buyers />} />
          <Route path="/buyer/:id" index element={<BuyersDetails />} />
          <Route path="/tasks" index element={<Tasks />} />
          <Route path="/touch-plans" index element={<Smartplan />} />
          <Route path="/touch-plan/:id" index element={<CreateSmartPlan />} />
          <Route path="/leads" index element={<Leads />} />
          <Route path="/pipeline" index element={<Pipeline />} />
          <Route path="/executedloi" index element={<ExecutedLOI />} />
          <Route path="/proposals" index element={<Proposals />} />
          <Route path="/ScoreCard" index element={<ScoreCard />} />
          <Route path="/settings/ScoreCardHistory" index element={<ScoreCardHistory />} />
          <Route path="/offers" index element={<Offers />} />
          <Route path="/exclusives" index element={<Exclusives />} />
          <Route path="/propertydemo" index element={<PropertiesDemo />} />
          <Route path="/under-contract" index element={<UnderContract />} />
          <Route path="/closed" index element={<Closed />} />
          <Route path="/stage_detail/:id" index element={<StageDetailPage />} />
          <Route path="/stage_detail-Archive/:id" index element={<StageDetailPageArchive />} />
          <Route path="/contact-close" index element={<ContractToClosed />} />
          <Route path="FilterData/:id/:propertyId" index element={<FilterData />} />
          <Route
            path="/add-contact-close"
            index
            element={<AddContractToClosed />}
          />
          <Route
            path="/settings/add-scorcard"
            index
            element={<AddScorecard />}
          />
          <Route
            path="/edit-contact-close/:id"
            index
            element={<EditContractToClosed />}
          />

          {/* Settings Routes */}
          <Route
            path="/settings/contact-archive"
            index
            element={<ContactArchive />}
          />
          <Route
            path="/settings/company-archive"
            index
            element={<CompanyArchive />}
          />
          <Route
            path="/settings/Contract-to-closed-archive"
            index
            element={<ContractToClosedArchive />}
          />
           <Route
            path="/settings/Logs"
            index
            element={<Logs />}
          />
          <Route
            path="/settings/property-archive"
            index
            element={<PropertyArchive />}
          />
          <Route
            path="/settings/buyer-archive"
            index
            element={<BuyerArchive />}
          />
          <Route
            path="/settings/executedloi-archive"
            index
            element={<ExecutedloiArchive />}
          />
          <Route
            path="/settings/exclusive-archive"
            index
            element={<EXclusiveArchive />}
          />
          <Route
            path="/settings/undercontract-archive"
            index
            element={<UnderContractArchive />}
          />
          <Route
            path="/settings/closed-archive"
            index
            element={<ClosedArchive />}
          />
          <Route path="/settings/contact-tags" index element={<ContactTag />} />
          <Route path="/settings/company-tags" index element={<CompanyTag />} />
          <Route
            path="/settings/lead-sources"
            index
            element={<LeadSources />}
          />

           <Route
            path="/settings/lead-type"
            index
            element={<LeadType />}
          />
            <Route
            path="/settings/lead-round-robin"
            index
            element={<LeadRoundRobin />}
          />
          <Route
            path="/settings/designated-agents"
            index
            element={<DesignatedAgents />}
          />
          <Route
            path="/settings/property-types"
            index
            element={<PropertyTypes />}
          />
           <Route
            path="/settings/converstion-rate"
            index
            element={<ConversationRate />}
          />
          <Route
            path="/settings/property-tags"
            index
            element={<PropertyTags />}
          />
          <Route path="/settings/tenant" index element={<Tenants />} />
          <Route path="/settings/Mailchimp" index element={<Mailchimp />} />
          <Route
            path="/settings/connected-app"
            index
            element={<ConnectedApp />}
          />
          <Route
            path="/settings/system-alerts"
            index
            element={<SystemAlerts />}
          />
          <Route
            path="/settings/profile"
            index
            element={userType === 1 ? <SuperAdminProfile /> : <Profile />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
